<script lang="ts" setup>
import constants from '~/constants'
import helpers from '~/helpers'

defineProps<{
  count: number
  isLoading: boolean
  query: string | null
}>()
</script>

<template>
  <div class="text-base leading-[1.27] text-main-dark sm:text-[22px] sm:font-medium">
    <span v-if="count !== 0 && query && query.length > 0" itemprop="numberOfItems">
      {{ count }} {{ helpers.getDeclension(count, constants.wordForms.product) }} по запросу «{{ query }}»
    </span>
    <span v-else-if="!query || query.length === 0">
      Каталог товаров
    </span>
    <span v-else>
      Простите, по вашему запросу “{{ query }}” ничего не найдено
    </span>
  </div>
</template>
